import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

export default function MenuSelectorContratos({
  isOpen,
  anchorRef,
  onClose,
  onContratoArras,
  onReconocimientoHonorarios,
  mostrarContratoArras = true,
  mostrarReconocimientoHonorarios = true,
  isDark,
  tx,
}) {
  const menuRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return undefined;
    const onDoc = (e) => {
      if (menuRef.current?.contains(e.target)) return;
      if (anchorRef?.current?.contains(e.target)) return;
      onClose?.();
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [isOpen, onClose, anchorRef]);

  if (!isOpen || !anchorRef?.current) return null;

  const rect = anchorRef.current.getBoundingClientRect();
  const item = {
    display: "block",
    width: "100%",
    textAlign: "left",
    padding: "8px 12px",
    fontSize: 12,
    fontWeight: 600,
    cursor: "pointer",
    border: "none",
    background: "transparent",
    color: tx,
    fontFamily: "inherit",
  };

  return createPortal(
    <div
      ref={menuRef}
      style={{
        position: "fixed",
        top: rect.bottom + 4,
        left: rect.left,
        minWidth: Math.max(rect.width, 200),
        zIndex: 9000,
        background: isDark ? "#1e2330" : "#fff",
        border: `1px solid ${isDark ? "#4a5568" : "#cbd5e1"}`,
        borderRadius: 8,
        boxShadow: "0 8px 24px rgba(0,0,0,0.25)",
        overflow: "hidden",
      }}
    >
      {mostrarContratoArras && (
        <button
          type="button"
          style={item}
          onMouseEnter={(e) => { e.currentTarget.style.background = isDark ? "#2d3748" : "#f1f5f9"; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
          onClick={() => { onClose?.(); onContratoArras?.(); }}
        >
          Contrato Arras
        </button>
      )}
      {mostrarReconocimientoHonorarios && (
        <button
          type="button"
          style={{ ...item, borderTop: mostrarContratoArras ? `1px solid ${isDark ? "#374151" : "#e2e8f0"}` : "none" }}
          onMouseEnter={(e) => { e.currentTarget.style.background = isDark ? "#2d3748" : "#f1f5f9"; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = "transparent"; }}
          onClick={() => { onClose?.(); onReconocimientoHonorarios?.(); }}
        >
          Reconocimiento honorarios
        </button>
      )}
    </div>,
    document.body,
  );
}
